import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createListEmpty } from "common/apis/savedplaces";
import { Storage } from "common/storage";

export function usePostCreateListEmpty() {
  const accessToken = Storage.getCurrentUserToken();
  const queryClient = useQueryClient();

  const { mutate, data, error, status } = useMutation({
    mutationFn: ({ name }: { name: string }) => {
      return createListEmpty(accessToken || "", name);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["getAllSavedPlaces"],
        exact: false,
      });
    },
  });

  return {
    createList: mutate,
    result: data,
    error,
    status,
    isLoading: status === "pending",
  };
}
